export default class IAScrollAnimation {
    constructor(target = new NodeList, header = new HTMLElement) {
        //const siteurl = window.location.origin + window.location.pathname
        if(target != undefined && header != undefined){
            const headerHeight = header.offsetHeight;
            target.forEach(anchorItem => {
                anchorItem.addEventListener('click', anchor => {
                    anchor.preventDefault();
                    const itemId = anchor.target.getAttribute('href').replace('#', '');
                    console.log(itemId)
                    let element = document.getElementById(itemId);
                    const elemScrollTo = window.pageYOffset + element.getBoundingClientRect().top;
                    window.scrollTo({
                        top: elemScrollTo - headerHeight - 20,
                        behavior: 'smooth'
                    });
                })
            })
        }
    }
    scollTo(id) {
        let element = document.getElementById(id);
        let headerHeight = document.querySelector('.section-header').offsetHeight;
        let elemScrollTo = window.pageYOffset + element.getBoundingClientRect().top;
        window.scrollTo({
            top: elemScrollTo - headerHeight - 20,
            behavior: 'smooth'
        });
    }
}